document.addEventListener(
  "DOMContentLoaded",
  function () {
    (function () {
      const scroll_carousels = document.querySelectorAll(
        'scroll-carousel[swipeable="true"], slideshow-carousel[swipeable="true"], .is-scrollable'
      );
      scroll_carousels.forEach((el) => {
        const carousel = el.querySelector(".sc-carousel-wrap, .product-list");
        let slider_position = "start";
        if (!carousel) return;

        let startX = 0;
        let scrollStart = 0;
        let isTouch = false;
        let moved = false;
        const threshold = 10;
        let isDragging = false;

        const onStart = (x, y, touch = false) => {
          isDragging = true;
          el.classList.add("dragging");
          if (el.classList.contains("js-carousel-controller-attached")) return;
          startX = x;
          scrollStart = carousel.scrollLeft;
          isTouch = touch;
          moved = false;
        };

        const onMove = (x, y) => {
          if (el.classList.contains("js-carousel-controller-attached")) return;
          if (!isDragging) return;
          const diffX = x - startX;
          if (Math.abs(diffX) > 5) {
            moved = true;
            carousel.scrollLeft = scrollStart - diffX;
          }
        };

        const onEnd = (x) => {
          isDragging = false;
          el.classList.remove("dragging");
          if (el.classList.contains("js-carousel-controller-attached")) return;

          const diff = x - startX;
          if (Math.abs(diff) > threshold) {
            if (diff < 0) {
              if (
                el.selectedSlide != el.nextSlide &&
                slider_position != "end"
              ) {
                el.select(el.selectedIndex + 1);
              }
            } else {
              if (
                el.selectedSlide != el.previousSlide &&
                slider_position != "start"
              ) {
                el.select(el.selectedIndex - 1);
              }
            }
          }
        };

        carousel.addEventListener(
          "touchstart",
          (e) => onStart(e.touches[0].clientX, e.touches[0].clientY, true),
          { passive: true }
        );
        carousel.addEventListener(
          "touchmove",
          (e) => onMove(e.touches[0].clientX, e.touches[0].clientY),
          { passive: false }
        );
        carousel.addEventListener("touchend", (e) =>
          onEnd(e.changedTouches[0].clientX)
        );

        el.addEventListener("scroll:edge-nearing", (event) => {
          slider_position = event.detail.position;
        });
        el.addEventListener("scroll:edge-leaving", (event) => {
          slider_position = "leave";
        });

        let isDown = false;
        carousel.addEventListener("mousedown", (e) => {
          isDown = true;
          onStart(e.clientX, e.clientY);
        });
        carousel.addEventListener("mousemove", (e) => {
          if (isDown) onMove(e.clientX, e.clientY);
        });
        carousel.addEventListener("mouseup", (e) => {
          if (!isDown) return;
          isDown = false;
          onEnd(e.clientX);
        });
        // carousel.addEventListener("mouseleave", () => {
        //   isDown = false;
        //   isDragging = false;
        //   el.classList.remove("dragging");
        // });

        carousel.addEventListener(
          "click",
          (e) => {
            if (moved) {
              const target = e.target.closest("a");
              if (target) {
                e.preventDefault();
                e.stopImmediatePropagation();
              }
            }
          },
          true
        );
      });

      document.addEventListener("keydown", (e) => {
        if (
          document.activeElement.tagName === "INPUT" ||
          document.activeElement.tagName === "TEXTAREA"
        )
          return;

        const activeCarousel = document.querySelector(
          'scroll-carousel[swipeable="true"]:hover, slideshow-carousel[swipeable="true"]:hover, .is-scrollable:hover'
        );
        if (!activeCarousel) return;

        if (e.key === "ArrowRight") {
          activeCarousel.dispatchEvent(
            new CustomEvent("control:next", { bubbles: true, cancelable: true })
          );
        } else if (e.key === "ArrowLeft") {
          activeCarousel.dispatchEvent(
            new CustomEvent("control:prev", { bubbles: true, cancelable: true })
          );
        }
      });
    })();

    (function () {
      const scPostsSliders = document.querySelectorAll(
        ".sc-popular-posts-slider"
      );

      scPostsSliders.forEach((scPostsSlider) => {
        const filterButtons = scPostsSlider.querySelectorAll(
          ".sc-popular-posts-slider-filter button"
        );
        const carousel = scPostsSlider.querySelector("scroll-carousel");
        const items =
          carousel.items ||
          Array.from(carousel.querySelectorAll("sc-article-card"));

        if (Boolean(filterButtons) && Boolean(carousel)) {
          function applyFilter(filterValue) {
            const activeFilters = filterValue.split(",").map((f) => f.trim());

            const filteredIndexes = items
              .map((item, index) => ({ item, index }))
              .filter(({ item }) => {
                const itemFilters = item.dataset.filters?.split(",") || [];
                return !itemFilters.some((tag) => activeFilters.includes(tag));
              })
              .map(({ index }) => index);

            carousel.dispatchEvent(
              new CustomEvent("carousel:filter", {
                bubbles: true,
                detail: { filteredIndexes },
              })
            );

            const firstVisible = items.findIndex(
              (item, index) => !filteredIndexes.includes(index)
            );
            if (firstVisible !== -1) {
              carousel.select(firstVisible, { animate: true, force: true });
            }
          }

          filterButtons.forEach((btn) => {
            btn.addEventListener("click", () => {
              const filter = btn.dataset.filter;
              filterButtons.forEach((b) => b.classList.remove("active"));
              btn.classList.add("active");
              applyFilter(filter);
            });
          });

          const initialBtn = filterButtons[0];
          if (initialBtn) {
            initialBtn.classList.add("active");
            applyFilter(initialBtn.dataset.filter);
          }
        }
      });
    })();
  },
  false
);

class SCSubscriptions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sc_selling_plan_input = this.querySelector(
      'input[name="selling_plan"]'
    );
    this.sc_selling_plans = this.querySelectorAll(".sc-selling_plan[data-id]");
    this.sc_selling_groups = this.querySelectorAll(".sc-selling_group");

    this.change_selling_plan = this.change_selling_plan.bind(this);

    this.sc_selling_plans.forEach((plan) => {
      plan.addEventListener("click", () => {
        this.change_selling_plan(plan.dataset.id);
      });
    });

    this.sc_selling_groups.forEach((group) => {
      const label = group.querySelector(".sc-selling_group_label");
      if (label) {
        label.addEventListener("click", () => {
          const first_plan = group.querySelector(".sc-selling_plan[data-id]");
          if (first_plan) {
            this.change_selling_plan(first_plan.dataset.id);
          }
        });
      }
    });

    //add event listener for variant change
    document.addEventListener("variant:change", (event) => {
      this.adjustPrice(event);
    });
  }

  change_selling_plan(selling_plan_id = "") {
    this.sc_selling_plan_input.value = selling_plan_id;

    this.sc_selling_groups.forEach((group) => {
      const is_active = !!group.querySelector(
        `.sc-selling_plan[data-id="${selling_plan_id}"]`
      );
      group.dataset.active = is_active ? "true" : "false";
    });

    this.sc_selling_plans.forEach((plan) => {
      plan.dataset.active =
        plan.dataset.id === selling_plan_id ? "true" : "false";
    });
  }


  adjustPrice(event) {
    const sellingPlanOneItem = document.querySelector(
      ".sc-selling_plan[data-id='']"
    );
    const sellingGroup = document.querySelectorAll(
      ".sc-selling_group .sc-selling_plan"
    );
    const currentVariant = event.detail.variant;
    const currentPrice = currentVariant.price;
    const currentSellingPlan = currentVariant.selling_plan_allocations;

    if (sellingPlanOneItem) {
      sellingPlanOneItem.querySelector(".sc-selling_plan-price").textContent =
        (Number(currentPrice) / 100).toFixed(2) + " " + Shopify.currency.active;
    }
    console.log(event);
    if (currentSellingPlan.length === sellingGroup.length) {
      currentSellingPlan.forEach((allocation, index) => {
       
        const price = (Number(allocation.price) / 100).toFixed(2) + " " + Shopify.currency.active
        if(document.querySelectorAll(".sc-selling_group")[index]){
          document.querySelectorAll(`.sc-selling_group`)[index].querySelector(".sc-selling_plan-price").textContent = price;
        }
        document.querySelector(
          `.sc-selling_plan[data-id="${allocation.selling_plan_id}"] .sc-selling_plan-price`
        ).textContent = price;
      });
    }
    sellingPlanOneItem.querySelector(".sc-selling_plan[data-id=''] .sc-selling_plan-price").textContent = (Number(event.detail.variant.price) / 100).toFixed(2) + " " + Shopify.currency.active;
  }
}

customElements.define("sc-subscriptions", SCSubscriptions);

class SCLocateSelector extends HTMLElement {
  constructor() {
    super();
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  connectedCallback() {
    this.top = this.querySelector(".sc-locate-selector_top");
    if (this.top) {
      this.top.addEventListener("click", this.toggleOpen);
    }
  }

  disconnectedCallback() {
    if (this.top) {
      this.top.removeEventListener("click", this.toggleOpen);
    }
  }

  toggleOpen() {
    this.classList.toggle("open");
  }
}

customElements.define("sc-locate-selector", SCLocateSelector);

class ScDrawerMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector("header.shopify-section--header");
    this.drawerId = this.id;
  }

  connectedCallback() {
    this.initDrawerTriggers();
    this.initOutsideClick();
    this.initAccordions();
  }

  initDrawerTriggers() {
    const triggers = this.header.querySelectorAll(
      `[data-sc-drawer-controll="${this.drawerId}"]`
    );

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const isOpen = this.classList.contains("active");

        this.classList.toggle("active");
        this.header.dataset.openDrawerMenu = isOpen ? "close" : "open";
        // document.body.style.overflow = isOpen ? "" : "hidden";
        // document.body.style.paddingRight = isOpen
        //   ? ""
        //   : "var(--scrollbar-width)";
      });
    });
  }

  initOutsideClick() {
    document.addEventListener("click", (event) => {
      const isInsideDrawer = event.target.closest(`#${this.drawerId}`);
      const isTrigger = event.target.closest(
        `[data-sc-drawer-controll="${this.drawerId}"]`
      );

      if (!isInsideDrawer && !isTrigger && this.classList.contains("active")) {
        this.classList.remove("active");
        this.header.dataset.openDrawerMenu = "close";
        // document.body.style.overflow = "";
        // document.body.style.paddingRight = "";
      }
    });
  }

  initAccordions() {
    const accordions = this.querySelectorAll("drawer-menu-accordeon");
    const steps = this.querySelectorAll("[data-step-add-handle]");

    const changeSteps = (handle) => {
      steps.forEach((step) => {
        if (step.dataset.stepAddHandle === handle) {
          step.classList.add("active");
        } else {
          step.classList.remove("active");
        }
      });
    };

    const toggleAccordion = (current) => {
      let openStep = false;

      accordions.forEach((accordion) => {
        const handle = current.dataset.accordeonLinkHandle;

        if (accordion === current) {
          const isActive = accordion.classList.contains("active");
          accordion.classList.toggle("active");
          openStep = !isActive;
        } else {
          accordion.classList.remove("active");
        }
      });

      changeSteps(openStep ? current.dataset.accordeonLinkHandle : "");
    };

    accordions.forEach((accordion) => {
      const top = accordion.querySelector(
        ".sc-drawer-menu_main_nav_accordeon_top"
      );
      if (top) {
        top.addEventListener("click", () => toggleAccordion(accordion));
      }
    });
  }
}

customElements.define("sc-drawer-menu", ScDrawerMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector("header.shopify-section--header");
  }

  connectedCallback() {
    this.mainLinks = this.header.querySelectorAll(
      '[data-main-megamenu="true"] [data-menu-link-handle]'
    );
    this.steps = this.querySelectorAll("[data-link-handle]");
    this.addLinks = this.querySelectorAll("[data-link-add-handle]");
    this.addSteps = this.querySelectorAll("[data-step-add-handle]");

    this.attachEventListeners();
    this.attachOutsideClickListener();
  }

  attachEventListeners() {
    this.mainLinks.forEach((link) => {
      const handle = link.dataset.menuLinkHandle;

      link.addEventListener("click", (event) => {
        event.preventDefault();

        if (
          link.classList.contains("active") ||
          !handle ||
          !link.classList.contains("has-children")
        ) {
          window.location.href = link.href;
        } else {
          this.changeMegaMenuStep(handle);
        }
      });
    });
  }

  changeMegaMenuStep(handle) {
    let open = false;

    this.mainLinks.forEach((link) => {
      link.classList.toggle("active", link.dataset.menuLinkHandle === handle);
    });

    this.steps.forEach((step) => {
      const isMatch = step.dataset.linkHandle === handle;
      step.classList.toggle("active", isMatch);
      if (isMatch) {
        open = true;

        const addHandle = step.querySelector("[data-link-add-handle]")?.dataset
          ?.linkAddHandle;
        if (addHandle) {
          this.changeAddStep(addHandle, false);
        }
      }
    });

    this.header.dataset.openMegaMenu = open ? "open" : "close";
  }

  changeAddStep(handle, setActive = true) {
    this.addLinks.forEach((link) => {
      const isMatch = link.dataset.linkAddHandle === handle;
      link.classList.toggle("active", setActive && isMatch);
      if (!setActive) link.classList.remove("active");
    });

    this.addSteps.forEach((step) => {
      step.classList.toggle("active", step.dataset.stepAddHandle === handle);
    });
  }

  attachOutsideClickListener() {
    document.addEventListener("click", (event) => {
      const isInsideMenu = event.target.closest("mega-menu");
      const isTrigger = event.target.closest(
        '[data-main-megamenu="true"] [data-menu-link-handle]'
      );

      if (!isInsideMenu && !isTrigger) {
        this.header.dataset.openMegaMenu = "close";

        this.mainLinks.forEach((link) => link.classList.remove("active"));
        this.steps.forEach((step) => step.classList.remove("active"));
        this.addLinks.forEach((link) => link.classList.remove("active"));
        this.addSteps.forEach((step) => step.classList.remove("active"));
      }
    });
  }
}

customElements.define("mega-menu", MegaMenu);

/* SC Carousel Supports */
class CarouselController {
  constructor(element) {
    this.element = element;
    this.carousel = element.querySelector(".sc-carousel-wrap");
    this.slideshow = element.querySelector("scroll-carousel") || element;

    this.slideSelector =
      element.getAttribute("selector") ||
      this.slideshow?.getAttribute("selector") ||
      ".sc-carousel-slide";
    this.bubbleSelector =
      element.getAttribute("bubble-selector") ||
      this.slideshow?.getAttribute("bubble-selector") ||
      ".sc-carousel-bubble";
    this.pointsSelector =
      element.getAttribute("points-selector") ||
      this.slideshow?.getAttribute("points-selector") ||
      ".sc-carousel-point[data-point-id]";
    this.pointsCardsMobileSelector =
      element.getAttribute("points-mobile-cards-selector") ||
      this.slideshow?.getAttribute("points-mobile-cards-selector") ||
      ".sc-carousel-point-card-mobile[data-point-id]";

    this.loop = element.getAttribute("loop") === "true";

    this.slides = Array.from(
      this.carousel.querySelectorAll(this.slideSelector)
    );
    this.prevButton = element.querySelector("[data-button-prev]");
    this.nextButton = element.querySelector("[data-button-next]");
    this.indicators = Array.from(
      element.querySelectorAll(".carousel-indicator")
    );
    this.menuItems = Array.from(element.querySelectorAll(".carousel-menu li"));
    this.bubbles = Array.from(element.querySelectorAll(this.bubbleSelector));
    this.points = Array.from(element.querySelectorAll(this.pointsSelector));
    this.pointsCardsMobile = Array.from(
      element.querySelectorAll(this.pointsCardsMobileSelector)
    );

    this.currentIndex = 0;
    this.currentPosition = 0;
    this.isDragging = false;
    this.isTransitioning = false;

    this.firstInit = true;

    // touch gesture helpers to avoid blocking vertical scroll
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchLock = null; // 'horizontal' | 'vertical' | null
    this.touchThreshold = 8; // px

    this.init();
  }

  init() {
    this.updateIndexes();

    if (this.loop) {
      this.cloneLoopSlides();
      this.currentIndex = 1;
    }

    this.bindEvents();
    //this.goTo(this.currentIndex, true);
    this.initPoints();
    this.initBubbleScroll();
    this.accessibility();

    this.element.classList.add("js-carousel-controller-attached");

    requestAnimationFrame(() => {
      this.goTo(this.currentIndex, true);
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.goTo(this.currentIndex, true);
      });
    });

    this.firstInit = true;

    this.updateIndicators();
  }

  bindEvents() {
    this.prevButton?.addEventListener("click", () => this.prev());
    this.nextButton?.addEventListener("click", () => this.next());

    this.indicators.forEach((el, i) =>
      el.addEventListener("click", () => this.goTo(i))
    );
    this.menuItems.forEach((el, i) =>
      el.addEventListener("click", () => this.goTo(i))
    );
    this.bubbles.forEach((el) =>
      el.addEventListener("click", () => this.bubbleSelect(el))
    );

    // touch events: only preventDefault when horizontal swipe is detected
    this.carousel.addEventListener(
      "touchstart",
      (e) => this.onTouchStart(e),
      { passive: true }
    );
    this.carousel.addEventListener(
      "touchmove",
      (e) => this.onTouchMove(e),
      { passive: false }
    );
    this.carousel.addEventListener("touchend", (e) => this.onTouchEnd(e));

    // mouse drag remains unchanged
    this.carousel.addEventListener("mousedown", (e) =>
      this.onDragStart(e.clientX)
    );
    this.carousel.addEventListener("mousemove", (e) =>
      this.onDragMove(e.clientX)
    );
    this.carousel.addEventListener("mouseup", () => this.onDragEnd());
    this.carousel.addEventListener("mouseleave", () => this.onDragEnd());

    window.addEventListener(
      "resize",
      this.debounce(() => this.goTo(this.currentIndex, true), 150)
    );
  }

  getSlides() {
    return Array.from(this.carousel.querySelectorAll(this.slideSelector));
  }

  updateIndexes() {
    const slides = this.getSlides().filter(
      (s) => !s.classList.contains("slide-duplicate")
    );
    slides.forEach((slide, i) => (slide.dataset.index = i.toString()));
  }

  cloneLoopSlides() {
    const realSlides = this.getSlides().filter(
      (s) => !s.classList.contains("slide-duplicate")
    );
    if (realSlides.length === 0) return;

    const first = realSlides[0].cloneNode(true);
    const last = realSlides[realSlides.length - 1].cloneNode(true);

    first.classList.add("slide-duplicate");
    last.classList.add("slide-duplicate");

    this.carousel.appendChild(first);
    this.carousel.insertBefore(last, realSlides[0]);
  }

  goTo(index, instantly = false) {
    if (this.isTransitioning) return;

    const slides = this.getSlides();
    const realSlides = slides.filter(
      (s) => !s.classList.contains("slide-duplicate")
    );

    if (!this.loop) {
      const lastIndex = realSlides.length - 1;

      if (index < 0) index = 0;
      if (index > lastIndex) index = lastIndex;

      if (index === this.currentIndex) return;
    }

    const target = slides[index];
    if (!target) return;

    this.isTransitioning = true;
    let offset;
    if (this.firstInit == true) {
      offset = -target.offsetWidth - 20;
      this.firstInit = false;
    } else {
      offset = -target.offsetLeft;
    }

    this.carousel.style.transition = instantly ? "none" : "transform 0.4s ease";
    this.carousel.style.transform = `translateX(${offset}px)`;
    this.currentPosition = offset;

    const isDuplicate = target.classList.contains("slide-duplicate");

    if (!isDuplicate) {
      this.currentIndex = index;
      this.updateIndicators();
    }

    const duration = instantly ? 10 : 400;

    setTimeout(() => {
      if (this.loop) {
        if (index === 0) {
          this.jumpTo(realSlides.length); // Jump from clone-first to real-last
        } else if (index === realSlides.length + 1) {
          this.jumpTo(1); // Jump from clone-last to real-first
        }
      }

      this.isTransitioning = false;
    }, duration);
  }

  jumpTo(index) {
    const slides = this.getSlides();
    const target = slides[index];
    if (!target) return;

    this.carousel.style.transition = "none";
    const offset = -target.offsetLeft;
    this.carousel.style.transform = `translateX(${offset}px)`;
    this.currentPosition = offset;
    this.currentIndex = index;

    this.updateIndicators();
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  prev() {
    this.goTo(this.currentIndex - 1);
  }

  updateIndicators() {
    const realIndex = parseInt(
      this.getSlides()[this.currentIndex]?.dataset.index || this.currentIndex,
      10
    );

    this.indicators.forEach((el, i) =>
      el.classList.toggle("active", i === realIndex)
    );
    this.menuItems.forEach((el, i) =>
      el.classList.toggle("active", i === realIndex)
    );

    const currentSlide = this.getSlides()[this.currentIndex];
    const bubbleId = currentSlide?.getAttribute("bubble-id");

    this.bubbles.forEach((bubble) => {
      const active = bubble.getAttribute("bubble-id") === bubbleId;
      if (!bubble.classList.contains("active") && active) {
        bubble.dispatchEvent(new Event("click"));
      }
      bubble.classList.toggle("active", active);
      if (active) {
        const container = bubble.closest(".sc-slider-with-bubble-bubbles");

        if (container) {
          const containerRect = container.getBoundingClientRect();
          const bubbleRect = bubble.getBoundingClientRect();
          container.scrollTo({
            left:
              bubble.offsetLeft -
              containerRect.width / 2 +
              bubbleRect.width / 2,
            behavior: "smooth",
          });
        }
      }
    });

    if (!this.loop) {
      this.prevButton?.toggleAttribute("disabled", realIndex === 0);
      this.nextButton?.toggleAttribute(
        "disabled",
        realIndex === this.getSlides().length - 1
      );
    }
  }

  onDragStart(x) {
    if (this.isTransitioning) return;
    this.dragStartX = x;
    this.diffX = 0;
    this.isDragging = true;
    this.carousel.style.transition = "none";
  }

  onDragMove(x) {
    if (!this.isDragging) return;

    const direction = x - this.dragStartX > 0 ? "prev" : "next";
    if (!this.canDragTo(direction)) return;

    this.diffX = x - this.dragStartX;
    let offset = this.currentPosition + this.diffX;

    const slides = this.getSlides();
    const firstSlide = slides[0];
    const lastSlide = slides[slides.length - 1];

    const minOffset = -lastSlide.offsetLeft;
    const maxOffset = -firstSlide.offsetLeft;

    if (!this.loop) {
      if (offset > maxOffset) offset = maxOffset + (offset - maxOffset) * 0.2;
      if (offset < minOffset) offset = minOffset + (offset - minOffset) * 0.2;
    }
    this.carousel.style.transform = `translateX(${offset}px)`;
  }

  onDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;

    if (Math.abs(this.diffX) > 50) {
      if (!this.canDragTo(this.diffX < 0 ? "next" : "prev")) {
        this.goTo(this.currentIndex);
        return;
      }

      this.diffX < 0 ? this.next() : this.prev();
    } else {
      this.goTo(this.currentIndex);
    }

    this.dragStartX = null;
    this.diffX = 0;
  }

  // touch helpers to detect gesture intent and avoid blocking vertical scroll
  onTouchStart(e) {
    const t = e.touches && e.touches[0];
    if (!t) return;
    this.touchStartX = t.clientX;
    this.touchStartY = t.clientY;
    this.touchLock = null;
    this.onDragStart(t.clientX);
  }

  onTouchMove(e) {
    const t = e.touches && e.touches[0];
    if (!t) return;

    const dx = Math.abs(t.clientX - this.touchStartX);
    const dy = Math.abs(t.clientY - this.touchStartY);

    if (!this.touchLock) {
      if (dx > dy && dx > this.touchThreshold) this.touchLock = "horizontal";
      else if (dy > dx && dy > this.touchThreshold) this.touchLock = "vertical";
    }

    if (this.touchLock === "horizontal") {
      // Only prevent default for intentional horizontal swipes
      e.preventDefault();
      this.onDragMove(t.clientX);
    } else if (this.touchLock === "vertical") {
      // Let the page scroll naturally; cancel any pending drag
      this.isDragging = false;
    }
  }

  onTouchEnd(e) {
    if (this.touchLock === "horizontal") {
      this.onDragEnd();
    } else {
      // No horizontal swipe completed
      this.isDragging = false;
      this.dragStartX = null;
      this.diffX = 0;
    }
    this.touchLock = null;
  }

  canDragTo(direction) {
    if (this.loop) return true;

    const realSlides = this.getSlides().filter(
      (s) => !s.classList.contains("slide-duplicate")
    );
    const lastIndex = realSlides.length - 1;

    if (direction === "prev" && this.currentIndex === 0) return false;
    if (direction === "next" && this.currentIndex === lastIndex) return false;

    return true;
  }

  bubbleSelect(bubble) {
    const id = bubble.getAttribute("bubble-id");
    const slides = this.getSlides().filter(
      (s) => !s.classList.contains("slide-duplicate")
    );
    const index = slides.findIndex((s) => s.getAttribute("bubble-id") === id);
    if (index !== -1) this.goTo(this.loop ? index + 1 : index);
  }

  initPoints() {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".sc-slider-with-bubble-slide_points-item_card"))
        return;

      let activePointId = null;
      this.points.forEach((point) => {
        const isClicked = e.composedPath().includes(point);
        const id = point.dataset.pointId;
        const wasActive = point.classList.contains("active");

        point.classList.toggle("active", isClicked && !wasActive);
        if (isClicked && !wasActive) activePointId = id;
      });

      this.pointsCardsMobile.forEach((card) => {
        card.classList.toggle("active", card.dataset.pointId === activePointId);
      });
    });
  }

  initBubbleScroll() {
    const container = this.bubbles[0]?.closest(
      ".sc-slider-with-bubble-bubbles"
    );
    if (!container) return;

    container.style.overflowX = "auto";
    container.style.touchAction = "pan-x";

    let startX = 0;
    let scrollStart = 0;

    container.addEventListener(
      "touchstart",
      (e) => {
        startX = e.touches[0].clientX;
        scrollStart = container.scrollLeft;
      },
      { passive: true }
    );

    container.addEventListener(
      "touchmove",
      (e) => {
        const dx = e.touches[0].clientX - startX;
        container.scrollLeft = scrollStart - dx;
      },
      { passive: true }
    );
  }

  accessibility() {
    this.element.addEventListener("mouseenter", () => (this.isHovered = true));
    this.element.addEventListener("mouseleave", () => (this.isHovered = false));
    window.addEventListener("keydown", (e) => {
      if (!this.isHovered) return;
      if (e.key === "ArrowLeft") this.prev();
      if (e.key === "ArrowRight") this.next();
    });
  }

  debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }
}

document
  .querySelectorAll(".sc-slideshow, scroll-carousel")
  .forEach((slideshow) => {
    if (Boolean(slideshow.querySelector(".sc-carousel-wrap"))) {
      new CarouselController(slideshow);
    }
  });

class LocationPopup extends HTMLElement {
  #anchor = null;
  #animationFrame = null;

  connectedCallback() {
    this.style.position = "fixed";
    this.hide();
  }

  showAt(triggerEl) {
    this.#anchor = triggerEl;
    this.classList.remove("hidden");
    this.updatePosition();
    this.trackPosition();
  }

  hide() {
    this.classList.add("hidden");
    this.#anchor = null;
    cancelAnimationFrame(this.#animationFrame);
  }

  updatePosition() {
    if (!this.#anchor) return;

    const iconEl = this.#anchor.querySelector(".stock_by_location-row-icon");
    if (!iconEl) return;

    const isMobile = window.innerWidth <= 1200;

    if (isMobile) {
      this.classList.add("mobile-mode");
      this.style.position = "fixed";
      this.style.top = "";
      this.style.left = "";
      this.style.transform = "";
      this.style.width = "";
      this.style.maxWidth = "";
      return;
    }

    this.classList.remove("mobile-mode");

    const iconRect = iconEl.getBoundingClientRect();
    const popupRect = this.getBoundingClientRect();

    const popupHeight = popupRect.height;
    const popupWidth = popupRect.width;
    const popupRight = popupRect.right;
    const margin = 70;

    const iconBottom = iconRect.bottom;
    const iconTop = iconRect.top;
    const iconRight = iconRect.right;

    let popupTop;

    popupTop = iconBottom - 70;
    const popupLeft = iconRight - 40;
    const maxLeft = window.innerWidth - popupWidth - 10;
    const finalLeft = Math.max(Math.max(popupLeft, 10), maxLeft);

    this.style.top = `${popupTop}px`;
    this.style.left = `${finalLeft}px`;

    const arrow = this.querySelector(".stock_by_location_popup_poligon");
    if (arrow) {
      arrow.style.right = `-10px`;
      arrow.style.left = `auto`;
    }
  }

  trackPosition() {
    const loop = () => {
      this.updatePosition();
      this.#animationFrame = requestAnimationFrame(loop);
    };
    this.#animationFrame = requestAnimationFrame(loop);
  }
}

(() => {
  const RECS_ENDPOINT =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root + 'recommendations/products.json') ||
    '/recommendations/products.json';

  const DEFAULT_INTENT = 'related';
  const DEFAULT_LIMIT = 10;

  function parseIdList(value) {
    if (!value) return [];
    return value
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }

class SCCartDrawerRecommendations extends HTMLDivElement {
  constructor() {
    super();
    this._initialized = false;
    this.slides = [];
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.run();
  }

  async run() {
    const incartIds = parseIdList(this.dataset.productIncartIds);
    const staticIds = parseIdList(this.dataset.productStaticIds);

    const incartHandles = parseIdList(this.dataset.productIncartHandles);
    const staticHandles = parseIdList(this.dataset.productStaticHandles);

    if (!incartIds.length && !staticHandles.length) {
      console.warn(
        '[sc-cart-drawer-recommendations] no incartIds and no staticHandles, nothing to render'
      );
      return;
    }

    const intent = this.dataset.intent || DEFAULT_INTENT;
    const limit = Number(this.dataset.limit) || DEFAULT_LIMIT;

    try {
      let recommendedHandles = [];

      if (incartIds.length) {
        recommendedHandles = await this.fetchRecommendationsForIds(
          incartIds,
          intent,
          limit
        );
      }

      const combinedHandles = [...staticHandles, ...recommendedHandles];

      const incartHandleSet = new Set(incartHandles.map(String));
      const seen = new Set();
      const finalHandles = [];

      for (const handle of combinedHandles) {
        const h = String(handle).trim();
        if (!h) continue;
        if (incartHandleSet.has(h)) continue;
        if (seen.has(h)) continue;
        seen.add(h);
        finalHandles.push(h);
      }

      if (!finalHandles.length) {
        console.warn(
          '[sc-cart-drawer-recommendations] finalHandles is empty after filter/dedupe'
        );
        return;
      }

      const slides = await this.loadSlidesForHandles(finalHandles);

      this.slides = slides;

      this.dispatchEvent(
        new CustomEvent('sc:cart-recommendations-loaded', {
          detail: {
            handles: finalHandles,
            slides,
          },
          bubbles: true,
        })
      );
    } catch (e) {
      console.error(
        '[sc-cart-drawer-recommendations] error while loading recommendations',
        e
      );
    }
  }

  async fetchRecommendationsForIds(incartIds, intent, limit) {
    const promises = incartIds.map((id) =>
      this.fetchRecommendationsForSingleProduct(id, intent, limit)
    );

    const results = await Promise.all(promises);
    const allHandles = [];

    for (const products of results) {
      for (const product of products) {
        if (product && product.handle) {
          allHandles.push(String(product.handle));
        }
      }
    }

    return allHandles;
  }

  async fetchRecommendationsForSingleProduct(productId, intent, limit) {
    const url =
      RECS_ENDPOINT +
      `?product_id=${encodeURIComponent(productId)}` +
      `&intent=${encodeURIComponent(intent)}` +
      `&limit=${encodeURIComponent(limit)}`;

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
      });

      if (!response.ok) {
        console.warn(
          '[sc-cart-drawer-recommendations] non-OK response',
          productId,
          response.status
        );
        return [];
      }

      const data = await response.json();
      return Array.isArray(data.products) ? data.products : [];
    } catch (e) {
      console.error(
        '[sc-cart-drawer-recommendations] fetch error for product',
        productId,
        e
      );
      return [];
    }
  }

  async loadSlidesForHandles(handles) {
    const root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/';

    const query =
      `section_id=cart-drawer` +
      `&cart-recommendations-handles=${handles.join(',')}`;

    const url = `${root}?${query}`;

    const response = await fetch(url, {
      credentials: 'same-origin',
    });

    if (!response.ok) {
      console.warn(
        '[sc-cart-drawer-recommendations] non-OK section response',
        response.status
      );
      return [];
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newWrapper = doc.querySelector(
      '.cart-drawer__recommendations[is="sc-cart-drawer-recommendations"]'
    );

    if (!newWrapper) {
      console.warn(
        '[sc-cart-drawer-recommendations] cannot find recommendations wrapper in section HTML'
      );
      return [];
    }

    const newList = newWrapper.querySelector('.horizontal-product-list');
    if (!newList) {
      console.warn(
        '[sc-cart-drawer-recommendations] missing .horizontal-product-list in section HTML'
      );
      return [];
    }

    const slides = Array.from(newList.children).map((node) =>
      node.cloneNode(true)
    );
    
    return slides;
  }
}

if (!customElements.get('sc-cart-drawer-recommendations')) {
  customElements.define(
    'sc-cart-drawer-recommendations',
    SCCartDrawerRecommendations,
    { extends: 'div' }
  );
}



})();

document.addEventListener('sc:cart-recommendations-loaded', (event) => {
  const { handles, slides } = event.detail;
  const host = event.target;

  // Init controller on wrapper (host), because prev/next buttons live outside <scroll-carousel>
  // but inside .cart-drawer__recommendations.
  const wrapperEl = host;
  const carouselEl = wrapperEl.querySelector('scroll-carousel, .sc-slideshow');
  if (!carouselEl) return;

  if (Boolean(wrapperEl.querySelector(".sc-carousel-wrap"))) {
    new CarouselController(wrapperEl);
  }

  // Prefer dynamic slide update if available
  const controller = carouselEl._scCarouselController;

  if (controller && typeof controller.setSlides === 'function') {
    controller.setSlides(slides);
  } else if (typeof carouselEl.setSlides === 'function') {
    carouselEl.setSlides(slides);
    if (typeof carouselEl.select === 'function') {
      try { carouselEl.select(0, { animate: false, force: true }); } catch (_) {}
    }
  } else {
    const wrap = carouselEl.querySelector('.sc-carousel-wrap') || carouselEl;
    if (wrap) {
      Array.from(wrap.children).forEach((node) => {
        if (!node.classList || !node.classList.contains('slide-duplicate')) node.remove();
      });
      slides.forEach((n) => {
        try {
          n.classList;
        } catch (_) {}
        wrap.appendChild(n);
      });
      try {
        carouselEl.dispatchEvent(new CustomEvent('carousel:items-changed', {
          bubbles: true,
          detail: { itemsLength: slides.length }
        }));
      } catch (_) {}
    }
  }
});

class LocationPopupTrigger extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(e) {
    const titleEl = e.target.closest(".stock_by_location-row-title u");
    if (!titleEl || !this.contains(titleEl)) return;

    this.togglePopup();
  }

  togglePopup() {
    const popupId = this.dataset.popupId;
    const popup = document.getElementById(popupId);
    if (!popup) return;

    // Hide all others
    document.querySelectorAll("location-popup").forEach((p) => p.hide());
    // Show this one
    popup.showAt(this);
  }
}

customElements.define("location-popup", LocationPopup);
customElements.define("location-popup-trigger", LocationPopupTrigger);

document.addEventListener("click", (e) => {
  if (
    !e.target.closest("location-popup") &&
    !e.target.closest("location-popup-trigger")
  ) {
    document.querySelectorAll("location-popup").forEach((p) => p.hide());
  }
});

document.addEventListener("click", (e) => {
  const close = e.target.closest(".stock_by_location_popup_close");
  const popup = e.target.closest("location-popup");
  if (close && popup) {
    popup.hide();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const sections_slider_with_bubbles = document.querySelectorAll(
    '[data-has-bubbles="true"]'
  );

  sections_slider_with_bubbles.forEach((slider) => {
    const next = slider
      .closest("section")
      .nextElementSibling.querySelector("[data-use-slider-bubbles]");

    if (
      next &&
      next.hasAttribute("data-use-slider-bubbles") &&
      next.dataset.useSliderBubbles == "true"
    ) {
      next.classList.add("hide-tag-filters");
      const next_section = next.closest("section");
      slider.querySelectorAll('[is="facet-link-for-next"]').forEach((link) => {
        link.addEventListener("click", () => {
          const href = link.getAttribute("href");
          const url = new URL(location.href);
          url.pathname = href;
          const sectionId = next_section.id.replace("shopify-section-", "");
          url.searchParams.set("section_id", sectionId);
          next_section.dispatchEvent(
            new CustomEvent("facet:update", {
              bubbles: true,
              detail: {
                url,
              },
            })
          );
        });
      });
    }
  });
});


(() => {
  const ELEMENT_NAME = 'sc-collection-tag-count';
  if (customElements.get(ELEMENT_NAME)) return;

  class ScCollectionTagCount extends HTMLElement {
    // ======== static “внутрішні” налаштування/кеш ========
    static _CACHE_KEY_PREFIX = 'sc:ctc:v2:'; // максимально унікально
    static _CACHE_TTL_MS = 10 * 60 * 1000;   // 10 хв
    static _mem = new Map();                 // handle -> Promise<Index|null>

  static _tagKey(v) {
  // Shopify-подібна нормалізація: пробіл/дефіс/underscore/різні тире = одне й те саме
  let s = String(v || '').trim().toLowerCase();

  // нормалізація юнікоду (щоб різні варіації символів були однакові)
  try { s = s.normalize('NFKC'); } catch (_) {}

  // "–" "—" і т.п. -> "-"
  s = s.replace(/[‐-‒–—―]/g, '-');

  // whitespace / underscore / hyphen -> single "-"
  s = s.replace(/[\s_-]+/g, '-');

  // прибрати дублікати "-" і краї
  s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');

  return s;
}


    static _normalize(v) {
      return String(v || '').trim().toLowerCase();
    }

    static _isDesignMode() {
      return (
        (window.Shopify && window.Shopify.designMode) ||
        document.documentElement.classList.contains('shopify-design-mode') ||
        document.body.classList.contains('shopify-design-mode')
      );
    }

    static _parseTagsAttr(value) {
      return String(value || '')
        .split(',')
        .map((t) => ScCollectionTagCount._tagKey(t))
        .filter(Boolean);
    }

    static _getHandleFromPathname(pathname) {
      const parts = String(pathname || '').split('/').filter(Boolean);
      const idx = parts.indexOf('collections');
      if (idx === -1) return null;
      return parts[idx + 1] || null;
    }

    static _inferHandle(el) {
      if (el.dataset.collectionHandle) return ScCollectionTagCount._normalize(el.dataset.collectionHandle);

      const a = el.querySelector('a[href*="/collections/"]');
      if (a) {
        try {
          const u = new URL(a.getAttribute('href'), window.location.origin);
          const h = ScCollectionTagCount._getHandleFromPathname(u.pathname);
          if (h) return h;
        } catch (_) {}
      }

      return ScCollectionTagCount._getHandleFromPathname(window.location.pathname);
    }

    static _readCache(handle) {
      try {
        const raw = sessionStorage.getItem(ScCollectionTagCount._CACHE_KEY_PREFIX + handle);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data?.ts || Date.now() - data.ts > ScCollectionTagCount._CACHE_TTL_MS) return null;
        return data;
      } catch (_) {
        return null;
      }
    }

    static _writeCache(handle, payload) {
      try {
        sessionStorage.setItem(ScCollectionTagCount._CACHE_KEY_PREFIX + handle, JSON.stringify(payload));
      } catch (_) {}
    }

    static async _fetchAllProducts(handle) {
      // Для ~200 товарів буде 1 запит (limit=250)
      const all = [];
      const LIMIT = 250;
      const MAX_PAGES = 60; // safety

      for (let page = 1; page <= MAX_PAGES; page++) {
        const url = `/collections/${encodeURIComponent(handle)}/products.json?limit=${LIMIT}&page=${page}`;
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) break;

        const json = await res.json();
        const products = Array.isArray(json?.products) ? json.products : [];
        all.push(...products);

        if (products.length < LIMIT) break;
      }
      return all;
    }

    static _extractTags(product) {
      const raw = product?.tags;
      const arr = Array.isArray(raw)
        ? raw
        : String(raw || '').split(',');

      return arr
        .map((t) => ScCollectionTagCount._tagKey(t))
        .filter(Boolean);
    }

    static _buildIndex(products) {
      const total = products.length;
      const tagToIdx = new Map();

      for (let i = 0; i < products.length; i++) {
        const tags = ScCollectionTagCount._extractTags(products[i]);
        for (const tag of tags) {
          if (!tagToIdx.has(tag)) tagToIdx.set(tag, []);
          tagToIdx.get(tag).push(i);
        }
      }

      // union marks
      const marks = new Uint32Array(total);
      let mark = 1;
      const getMark = () => {
        mark = (mark + 1) >>> 0;
        if (mark === 0) mark = 1;
        return mark;
      };

      // intersection counters (cleanup only touched)
      const present = new Uint8Array(total);
      const touched = new Uint32Array(total);

      return { total, tagToIdx, marks, getMark, present, touched };
    }

    static _restoreIndexFromCache(cached) {
      const total = Number(cached.total || 0);

      const tagToIdx = new Map();
      for (const [k, v] of Object.entries(cached.tagToIdx || {})) {
        if (Array.isArray(v)) tagToIdx.set(k, v);
      }

      const marks = new Uint32Array(total);
      let mark = 1;
      const getMark = () => {
        mark = (mark + 1) >>> 0;
        if (mark === 0) mark = 1;
        return mark;
      };

      const present = new Uint8Array(total);
      const touched = new Uint32Array(total);

      return { total, tagToIdx, marks, getMark, present, touched };
    }

    static _unionCount(arrays, idx) {
      if (!arrays.length) return 0;
      const mark = idx.getMark();
      let count = 0;

      for (const arr of arrays) {
        for (let i = 0; i < arr.length; i++) {
          const p = arr[i];
          if (idx.marks[p] !== mark) {
            idx.marks[p] = mark;
            count++;
          }
        }
      }
      return count;
    }

    static _intersectionCount(arrays, idx) {
      const k = arrays.length;
      if (!k) return 0;
      if (k === 1) return arrays[0].length;

      let touchedLen = 0;

      for (let a = 0; a < k; a++) {
        const arr = arrays[a];
        for (let i = 0; i < arr.length; i++) {
          const p = arr[i];
          if (idx.present[p] === 0) idx.touched[touchedLen++] = p;
          idx.present[p]++;
        }
      }

      let count = 0;
      for (let i = 0; i < touchedLen; i++) {
        const p = idx.touched[i];
        if (idx.present[p] === k) count++;
        idx.present[p] = 0;
      }

      return count;
    }

    static _getCollectionIndex(handle) {
      if (!handle) return Promise.resolve(null);
      if (ScCollectionTagCount._mem.has(handle)) return ScCollectionTagCount._mem.get(handle);

      const p = (async () => {
        const cached = ScCollectionTagCount._readCache(handle);
        if (cached) return ScCollectionTagCount._restoreIndexFromCache(cached);

        const products = await ScCollectionTagCount._fetchAllProducts(handle);
        const idx = ScCollectionTagCount._buildIndex(products);

        // Зберігаємо мінімум у sessionStorage: total + tag->indices
        const obj = {};
        for (const [tag, arr] of idx.tagToIdx.entries()) obj[tag] = arr;
        ScCollectionTagCount._writeCache(handle, { ts: Date.now(), total: idx.total, tagToIdx: obj });

        return idx;
      })().catch(() => null);

      ScCollectionTagCount._mem.set(handle, p);
      return p;
    }

    // ======== lifecycle ========
    static get observedAttributes() {
      return [
        'data-tag',
        'data-tag-mode',
        'data-count-target',
        'data-count-template',
        'data-collection-handle',
      ];
    }

    constructor() {
      super();
      this._raf = 0;
    }

    connectedCallback() {
      if (ScCollectionTagCount._isDesignMode()) return;
      this._schedule();
    }

    attributeChangedCallback() {
      if (ScCollectionTagCount._isDesignMode()) return;
      this._schedule();
    }

    disconnectedCallback() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = 0;
    }

    _schedule() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => {
        this._raf = 0;
        this._update().catch(() => {});
      });
    }

    _resolveTarget() {
      const sel = this.dataset.countTarget || this.dataset.countSelector || '';
      if (sel) {
        const t = this.querySelector(sel);
        if (t) return t;
      }

      // fallback: створюємо span в heading
      const heading = this.querySelector('.heading') || this;
      let span = heading.querySelector('[data-tag-count]');
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('data-tag-count', '');
        span.style.marginLeft = '6px';
        heading.appendChild(span);
      }
      return span;
    }

    _renderCount(count) {
      const target = this._resolveTarget();
      const tpl = this.dataset.countTemplate || '{count}';
      target.textContent = tpl.replace('{count}', String(count));
      this.dataset.count = String(count);

      const a = this.querySelector('a[aria-label]');
      if (a) {
        const base = a.getAttribute('aria-label') || '';
        a.setAttribute('aria-label', `${base} (${count})`);
      }
    }

    async _update() {
      const handle = ScCollectionTagCount._inferHandle(this);
      if (!handle) return;

      this.classList.add('sc-count-loading');

      const idx = await ScCollectionTagCount._getCollectionIndex(handle);
      if (!idx) {
        this.classList.remove('sc-count-loading');
        return;
      }

      const tags = ScCollectionTagCount._parseTagsAttr(this.dataset.tag);
      const mode = ScCollectionTagCount._normalize(this.dataset.tagMode || 'any'); // any|all

      if (!tags.length) {
        this._renderCount(idx.total);
        this.classList.remove('sc-count-loading');
        return;
      }

      const arrays = tags.map((t) => idx.tagToIdx.get(t) || null).filter(Boolean);

      let count = 0;
      if (mode === 'all') {
        count = arrays.length !== tags.length ? 0 : ScCollectionTagCount._intersectionCount(arrays, idx);
      } else {
        count = ScCollectionTagCount._unionCount(arrays, idx);
      }

      this._renderCount(count);
      this.classList.remove('sc-count-loading');
    }
  }

  customElements.define(ELEMENT_NAME, ScCollectionTagCount);
})();

if (!customElements.get("sc-variant-option-cards")) {
  class ScVariantOptionCards extends HTMLElement {
    connectedCallback() {
      this.scAbortController = new AbortController();
      this.scForm = document.forms[this.getAttribute("form-id")];
      this.scOptionPosition = Number(this.getAttribute("option-position"));
      this.scHideSoldOut = this.dataset.scHideSoldOut === "true";
      this.scVariants = this.scParseVariants();
      this.scHandleUpdate = this.scScheduleUpdate.bind(this);

      this.scForm?.addEventListener("change", this.scHandleUpdate, {
        signal: this.scAbortController.signal,
      });
      this.scForm?.addEventListener("variant:change", this.scHandleUpdate, {
        signal: this.scAbortController.signal,
      });

      this.scScheduleUpdate();
    }

    disconnectedCallback() {
      this.scAbortController?.abort();

      if (this.scRaf) {
        cancelAnimationFrame(this.scRaf);
      }
    }

    scParseVariants() {
      const script = this.querySelector("[data-sc-variants]");

      if (!script) {
        return [];
      }

      try {
        return JSON.parse(script.textContent || "[]");
      } catch (error) {
        return [];
      }
    }

    scScheduleUpdate() {
      if (this.scRaf) {
        cancelAnimationFrame(this.scRaf);
      }

      this.scRaf = requestAnimationFrame(() => {
        this.scRaf = 0;
        this.scUpdateCards();
      });
    }

    scUpdateCards() {
      if (!this.scForm || !this.scVariants.length || !this.scOptionPosition) {
        return;
      }

      const selectedOptionValueIds = this.scSelectedOptionValueIds();

      this.querySelectorAll("[data-sc-option-card-input]").forEach((input) => {
        const optionValueIds = [...selectedOptionValueIds];
        optionValueIds[this.scOptionPosition - 1] = input.value;

        this.scUpdateCard(input, this.scFindVariant(optionValueIds));
      });
    }

    scSelectedOptionValueIds() {
      return Array.from(this.scForm.elements)
        .filter((item) => item.matches("input[data-option-position]:checked"))
        .sort(
          (a, b) =>
            Number(a.getAttribute("data-option-position")) -
            Number(b.getAttribute("data-option-position"))
        )
        .map((input) => input.value);
    }

    scFindVariant(optionValueIds) {
      return this.scVariants.find((variant) => {
        if (!Array.isArray(variant.option_value_ids)) {
          return false;
        }

        return variant.option_value_ids.every(
          (optionValueId, index) =>
            String(optionValueId) === String(optionValueIds[index])
        );
      });
    }

    scUpdateCard(input, variant) {
      const card = input.nextElementSibling;

      if (!card) {
        return;
      }

      const unavailable = !variant || variant.available === false;
      const priceTarget = card.querySelector("[data-sc-price-target]");
      const unitPriceTarget = card.querySelector("[data-sc-unit-price-target]");
      const badgeTarget = card.querySelector("[data-sc-badge-target]");

      if (priceTarget) {
        priceTarget.textContent = variant?.price_text || "";
      }

      if (unitPriceTarget) {
        unitPriceTarget.textContent = variant?.unit_price_text || "";
      }

      if (badgeTarget) {
        const badgeText = variant?.badge_text || "";

        badgeTarget.textContent = badgeText;
        badgeTarget.hidden = !badgeText;
      }

      input.disabled = this.scHideSoldOut && unavailable && !input.checked;
      card.classList.toggle("sc-is-disabled", unavailable);

      if (unavailable) {
        card.setAttribute("aria-disabled", "true");
      } else {
        card.removeAttribute("aria-disabled");
      }
    }
  }

  customElements.define("sc-variant-option-cards", ScVariantOptionCards);
}
